import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LeadUtilsService {
  constructor() {}

  public isStatusEnabledForUpdate(isCS, nu_dse__Prospect_Status__c) {
    // los usuarios de costumer service pueden editar
    if (isCS) {
      return false;
    }

    const listStatus = [
      "Signed Contract-WC Ready",
      // "Signed Contract - Pending Review",
      "Signed Contract Received (DS)",
      "Signed Contract Received - WC Not Answered (DS)",
    ];

    // si el status es uno de los que estan en listStatus no se puede editar y retornamos true
    if (listStatus.includes(nu_dse__Prospect_Status__c)) {
      return true;
    } else {
      return false;
    }
  }
}
